import {observable, action, runInAction, computed} from 'mobx'
import { get, json } from '../../../../utils/ajax'
import {handleSeerchAndPage,setStore} from '../../../../utils/Utils'

class CategoryStore {

    @observable categoryList//列表数据
    @observable categoryPagination//分页器
    @observable loading //页面是否加载
    @observable modal //模态框是否显示
    @observable searchFields//搜索框
    @observable pageList //下拉框
    @observable editFields//修改
    @observable modalTitle  //模态框名字

    constructor() {
        this.categoryList = []
        this.categoryPagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.loading = false
        this.modal = false
        this.searchFields = {
            name: '',
            pageId: ''
        }
        this.pageList = []
        this.editFields = {
            id: '',
            pageId: '',
            name: ''
        }
        this.modalTitle = ''
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }


    /**
     *  栏目-分页
     *
     */
    @action
    initCategoryPage = async (page) => {
        this.loading = true
        let search = handleSeerchAndPage(page, this.categoryPagination, this.searchFields)
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/category/category_page:search`, search)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.categoryList = res.content || []
            this.categoryPagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
            this.loading = false
        })
    }

    /**
     * 页面下拉框
     * @returns {Promise.<void>}
     */
    @action getPageList = async () => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/page/list`)
        runInAction(() => {
            this.pageList = Array.isArray(res)? res : []
            this.loading = false
        })
    }

    /**
     * 搜索框：平行化表单，传值给form
     */
    @computed
    get fields() {
        let fields = {
            name: {value: this.searchFields.name},
            pageId: {value: this.searchFields.pageId}
        }
        return fields
    }

    /**
     * 将表单时对象化，绑值给store。form
     */
    @action
    onSearchFieldChange = (changedFields) => {
        const fields = {...this.fields, ...changedFields}
        let searchFields = {
            name: fields.name.value ? fields.name.value : '',
            pageId: fields.pageId.value ? fields.pageId.value : ''
        }
        this.searchFields = searchFields
    }

    /**
     * 搜索框：清空
     */
    @action
    clearSearchForm = () => {
        runInAction(() => {
            this.loading = this
            this.searchFields = {
                name: '',
                pageId: ''
            }
            this.loading = false
        })
    }

    /**
     * 新增-修改 平行化
     * @returns {{name: {value: string}}}
     */
    @computed
    get fieldsEdit() {
        let editFields = {
            id: {value: this.editFields.id},
            name: {value: this.editFields.name},
            pageId: {value: this.editFields.pageId}
        }
        return editFields
    }

    /**
     * 新增-修改 数据回写
     * @param changedFields
     */
    @action
    onEditFieldChange(changedFields) {
        const fields = {...this.fieldsEdit, ...changedFields}
        let editFields = {
            id: fields.id.value ? fields.id.value : '',
            name: fields.name.value ? fields.name.value.trim() : '',
            pageId: fields.pageId.value ? fields.pageId.value : ''
        }
        this.editFields = editFields
    }

    /**
     *  弹窗：显示
     *  record:  不存在:新增   存在：修改
     */
    @action showModal = (record) => {
        runInAction(() => {
            this.loading = true
            this.modal = true
            // this.categoryList.map(i=> {
            //     if (i.name===record.name) {
            //
            //     }
            // })
            if (!record) {        //新增
                this.editFields = {
                    id: '',
                    pageId: '',
                    name: ''
                }
                this.modalTitle = '新增'
            } else {     //修改
                this.editFields = record
                this.modalTitle = '修改'
            }
            this.loading = false
        })
    }

    /**
     * 弹窗：关闭
     */
    @action
    closeModal = () => {
        runInAction(() => {
            this.loading = true
            this.editFields = {
                id: '',
                pageId: '',
                name: ''
            }
            this.modal = false
            this.loading = false
        })
    }

    /**
     * 保存：新增/修改
     */
    @action saveCategory = async () => {
        runInAction(() => {
            this.loading = true
        })
        if (!this.editFields.id) {
            await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/category/add`, this.editFields)  //新增
        } else {
            await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/category/update`, this.editFields)  //修改
        }
        runInAction(() => {
            this.modal = false
            this.editFields = {}
            this.loading = false
        })
        this.initCategoryPage(this.categoryPagination.current)
    }

    /**
     * 删除
     * 栏目下有新闻是不允许删除栏目的
     * @param id
     * @returns {Promise.<void>}
     */
    @action
    deleteCategory = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/category/delete?id=${id}`)
        this.initCategoryPage(this.categoryPagination.current)
        runInAction(() => {
            this.loading = false
        })
    }

    /**
     * 启用栏目
     * @param id
     * @returns {Promise.<void>}
     */
    @action
    releaseCategory = async (id) => {
        runInAction(() => this.loading = true)
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/category/release/${id}`)
        this.initCategoryPage(this.categoryPagination.current)
        runInAction(() => this.loading = false)
    }

    /**
     * 停用栏目
     * 如果该栏目下有新闻启用，不允停用
     * @param id
     * @returns {Promise.<void>}
     */
    @action
    stopCategory = async (id) => {
        runInAction(() => this.loading = true)
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/category/stop/${id}`)
        this.initCategoryPage(this.categoryPagination.current)
        runInAction(() => this.loading = false)
    }

    /**
     *  查询栏目下是否有新闻
     */
    @action existNewsType = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/news/news_list/${id}`)
        if (res && res.status === 0) {
            return
        } else {
            runInAction(() => {
                this.loading = false
            })
            return res.length
        }
    }

    /**
     *  查询停止新闻
     */
    @action findStopNewsList = async (categoryId) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/bjml/cms/news/stop_list/${categoryId}`)
        if (res && res.status === 0) {
            return
        } else {
            runInAction(() => {
                this.loading = false
            })
            return res.length
        }
    }
}
export default new CategoryStore()


// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/sparePartsCatalogueNews/Category/store.js